__webpack_require__.hmrF = () => ("single-spa_config." + __webpack_require__.h() + ".hot-update.json");